import { fork, take, cancel, call, put } from 'redux-saga/effects';
import { LoginActionTypes } from '../login/types';
import { handleOktaTokenRefresh } from '../login/sagas';
import { SagaIterator } from 'redux-saga';
import { getStorage } from '../utils/storage/storage.manager';
import { navigateTo } from '../case/actions';
import { LoginStorageModel, LoginOktaStorageModel } from '../login/model';

export function* authSessionSaga(): SagaIterator {
  while (true) {
    // Any successful login starts a session
    yield take(LoginActionTypes.OKTA_SESSION_STARTED);

    // Start background refresh loop
    const refreshTask = yield fork(handleOktaTokenRefresh);

    // Wait until session truly ends
    const action = yield take([
      LoginActionTypes.LOGOUT,
      LoginActionTypes.SESSION_EXPIRED,
    ]);


    // Stop refresh cleanly
    yield cancel(refreshTask);

    
    if (action.type === LoginActionTypes.SESSION_EXPIRED) {
      const storage = getStorage();
      yield call(() => storage.getInstance(LoginStorageModel).clear());
      yield call(() => storage.getInstance(LoginOktaStorageModel).clear());
    }

  }
}
